import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Platform, Pressable } from 'react-native'
import useAnimatedPress from '@ui/animated/useAnimatedPress'
import Button from '@ui/buttons/Button'
import EyetestModal from '@order/modals/Eyetest/EyetestModal'
import TileBlur from '@ui/tiles/TileBlur'
import { useCustomer } from 'hooks/useSession'

export default function PrescriptionNew() {
  const [modalOpen, setModalOpen] = useState(false)
  const { t } = useTranslation(['vision'])
  const { animation, onPressIn, onPressOut } = useAnimatedPress()
  const text = 'vision:source.sections.new'
  const customer = useCustomer()

  const onPress = () => setModalOpen(true)

  return (
    <>
      <Pressable
        onPress={onPress}
        onPressIn={onPressIn}
        onPressOut={onPressOut}
        className="flex-1"
      >
        <TileBlur
          variant="option"
          title={t(`${text}.title`)}
          desc={t(`${text}.desc`)}
          cta={
            <Button
              noninteractive
              animation={animation}
              onPress={onPress}
              size="sm"
              variant="outlined"
              label={t(`${text}.cta`)}
            />
          }
          glassProps={{
            animation,
            image: require('@/images/eyetest.png'),
            imageStyle: {
              transform: [{ translateX: 1 }, { translateY: 1 }],
            },
            blur: Platform.select({ default: 75, web: 75 }),
            blurStyle: {
              transform: [
                { translateX: -75 },
                { translateY: -75 },
                { scale: 1 },
                { rotate: '-15deg' },
              ],
            },
          }}
        />
      </Pressable>
      <EyetestModal
        key={customer?.id}
        open={modalOpen}
        close={() => setModalOpen(false)}
      />
    </>
  )
}
